import { useState } from 'react';
import useScrolled from '../hooks/useScrolled';
import './Header.css';

const LINKS = [
  { href: '#sakums', label: 'Sākums' },
  { href: '#davanu-karte', label: 'Dāvanu karte' },
  { href: '#masazas', label: 'Masāžas' },
  { href: '#proceduras', label: 'Procedūras' },
  { href: '#kontakti', label: 'Kontakti' },
];

export default function Header() {
  const scrolled = useScrolled(40);
  const [open, setOpen] = useState(false);

  return (
    <header className={`site-header ${scrolled ? 'is-solid' : ''} ${open ? 'is-open' : ''}`}>
      <div className="container site-header__bar">
        <a href="#sakums" className="site-header__brand" onClick={() => setOpen(false)}>
          Siluets
        </a>

        <nav className="site-header__nav" aria-label="Galvenā navigācija">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href}>
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#kontakti" className="btn btn-outline site-header__cta">
          Sazināties
        </a>

        <button
          className="site-header__toggle"
          aria-label={open ? 'Aizvērt izvēlni' : 'Atvērt izvēlni'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <nav className={`site-header__mobile ${open ? 'is-open' : ''}`} aria-label="Mobilā navigācija">
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} onClick={() => setOpen(false)}>
            {l.label}
          </a>
        ))}
      </nav>
    </header>
  );
}
